import React, { useEffect, useState } from "react";
import '../ParaFacturacion.scss';
import { obtenerLunesADomingo } from "../../../../utilidades/formateos";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";

import { Button } from "primereact/button";
import { Tooltip } from "@mui/material";
import { getClientes } from "../../../admin/Bitacoras/integracion";
const FiltrosParaFacturacion = ({
    fechaInicio,
    setFechaInicio,
    fechaFin,
    setFechaFin,
    setCliente,
    cliente,
    onBuscar
}) => {

    const [clientes, setClientes] = useState([]);
    useEffect(() => {
        setFechaInicio(obtenerLunesADomingo().lunes);
        setFechaFin(obtenerLunesADomingo().domingo);
        getClientes(setClientes)
    }, [])


    return (
        <div className="filtros">
            <div className="generales">


                <Calendar
                    value={fechaInicio}
                    onChange={(e) => setFechaInicio(e.value)}
                    placeholder="Fecha de inicio"
                    showIcon
                    dateFormat="dd/mm/yy"

                ></Calendar>
                <Calendar
                    value={fechaFin}
                    onChange={(e) => setFechaFin(e.value)}
                    placeholder="Fecha de fin"
                    showIcon
                    dateFormat="dd/mm/yy"

                ></Calendar>
                <Dropdown
                    filter
                    options={clientes}
                    value={cliente}
                    onChange={(e) => setCliente(e.value)}
                    placeholder="Selecciona un cliente"
                    className="dropdown-cliente"
                    optionLabel="name"
                ></Dropdown>
                <Button
                    severity="primary"
                    icon="pi pi-search"
                    onClick={()=>{onBuscar()}}
                >Buscar</Button>
            </div>
          
        </div >
    )
}
export default FiltrosParaFacturacion;